import type { Nullable } from 'corgi-types';
import type { AdditionalServiceType } from 'graphql-ts-types';

import { CartEvent } from '../enums/Tracking';
import type { ArticleTracking } from '../types/Article';
import type { Assembly } from './productEventData';
import {
  getAssemblyServiceEventData,
  getProductAddEventData,
  getProductRemoveEventData,
} from './productEventData';

export const getCartEventData = ({
  event,
  tracking,
  quantity,
  tax,
  services,
  couponCode,
  changeValue,
  resultValue,
  assembly,
  couponDiscountAmount,
}: {
  event: CartEvent;
  changeValue: number;
  resultValue: number;
  tracking: ArticleTracking;
  quantity: number;
  tax?: number;
  assembly?: Assembly;
  services?: AdditionalServiceType[];
  couponCode?: string;
  couponDiscountAmount?: Nullable<number>;
}) => {
  const getTrackingProps =
    event === CartEvent.AddToCart ? getProductAddEventData : getProductRemoveEventData;
  const cartItemTrackingProps = getTrackingProps({
    tracking,
    quantity,
    tax,
    services,
    couponCode,
    couponDiscountAmount,
  });

  return {
    event,
    change_value: changeValue,
    result_value: resultValue,
    value: cartItemTrackingProps.price,
    currency: tracking.productPriceCurrency,
    items: [cartItemTrackingProps, ...getAssemblyServiceEventData(services, assembly)],
  };
};
